<template>
  <v-row no-gutters>
    <!-- 统计绘图列表 -->
    <v-col cols="12" class="pa-0">

      <v-card outlined>
        <!-- <v-card-title>统计绘图列表</v-card-title> -->
        <v-card-text style="overflow: auto;">
          <!-- <table-editor v-bind="tableEditorProps" v-model="srs" style="word-break: inherit;" /> -->
          <data-table :config="tableOption" :matrix="dataSource" ref="dataTable"></data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { userFileStream } from '@/plugins/api';
import DataTable from '@/views/Component/DataTable.vue';

export default {
  props: ['dataSourceParam', 'dataSource'],
  data () {
    return {}
  },
  computed: {
    tableOption () {
      let ret = { cols: [], props: { 'checkbox-config': { checkAll: true } } }, r0 = this.dataSource[0], cols = [0, 1, 2, 3, 5, 8, 9, 10];
      for (let i = 0; i < r0.length; i++) {
        let col = { field: i };
        if (i == 0) {
          col.type = 'html';
          col.formatter = ({ cellValue }) => `<a href="http://www.kegg.jp/kegg-bin/show_pathway?ko${cellValue}" target="_blank">${cellValue}</a>`
        }
        if (cols.indexOf(i) == -1) col.visible = false;
        ret.cols.push(col);
      }
      ret.events = {
        'checkbox-change': this.updateChartData,
        'checkbox-all': this.updateChartData
      }
      ret.tools = [{ name: '下载', color: 'primary', text: true, click: this.onDownloadFile }];
      return ret;
    }
  },
  components: { DataTable },
  methods: {
    // =============== 勾选绘图表格
    updateChartData () {
      let xTable = this.$refs.dataTable.$refs.xTable;
      let srs = xTable.getCheckboxRecords();
      this.$emit('change', srs);
    },
    // =============== 文件下载
    onDownloadFile () {
      userFileStream(this.dataSourceParam);
    }
  }
}
</script>